import React, { createContext, useState, useEffect, useCallback } from "react";
import { env } from "../utils/env";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUserData = useCallback(async () => {
    const token = localStorage.getItem("jwt");

    try {
      setLoading(true);
      const response = await fetch(`${env.API_URL}/auth/me`, {
        method: "GET",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.ok) {
        setUser(data?.user);
      } else {
        // localStorage.clear()
        setUser(null);
      }
    } catch (error) {
      setUser(null);
      // localStorage.clear()

    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  return (
    <UserContext.Provider
      value={{ user, loading, setUser, refetchUser: fetchUserData }}
    >
      {children}
    </UserContext.Provider>
  );
};
